declare namespace $ {

	export class $shm_dotsloader extends $mol_view {
		title( ): string
		Dot_first( ): $mol_view
		Dot_second( ): $mol_view
		Dot_third( ): $mol_view
		attr( ): Record<string, any> & ReturnType< $shm_dotsloader['title'] >
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=dotsloader.view.tree.d.ts.map